<template>
  <!-- 分割线组件
      @author: 王汝鹏
      @date: 2019-9-20
  -->
  <div v-if="isDisplay"
       class="preview-item_line"
       :style="{'padding-left': paddingLeft}">
    <div class="line-wrapper" :style="{justifyContent: textPosition}">
      <span class="text" >{{lineText}}</span>
      <div class=line :style="{borderStyle: lineStyle, width}"></div>
    </div>
  </div>
</template>
<script>
/** 混入方法 ::: 
 *  @mixin mixPreviewItemTemplateChild 预览表单项子级混入
 */
import { mixPreviewItemTemplateChild } from "@/mixins/preview_item/mix_preview_item_template_child.js";

export default {
  mixins: [ mixPreviewItemTemplateChild ],
}
</script>


// WEBPACK FOOTER //
// src/components/preview_item/PreviewItemLine.vue